import { useEffect } from "react";

const SITE_URL = "https://abraliber.com.br";
const DEFAULT_IMAGE = `${SITE_URL}/og-abraliber-v2.png`;

const setMeta = (name, content) => {
  if (!content) return;
  let element = document.querySelector("meta[name=\"" + name + "\"]");
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("name", name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

const setPropertyMeta = (property, content) => {
  if (!content) return;
  let element = document.querySelector(`meta[property="${property}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("property", property);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

const setCanonical = (url) => {
  if (!url) return;
  let element = document.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }
  element.setAttribute("href", url);
};

const removeCanonical = () => {
  document.querySelector('link[rel="canonical"]')?.remove();
  document.querySelector('meta[property="og:url"]')?.remove();
};

// O HTML renderizado no servidor traz JSON-LD da página inicial; ao navegar no SPA
// ele deixa de descrever a página atual e precisa sair do <head>.
const removeStaleServerSchemas = (currentUrl) => {
  document.querySelectorAll('script[data-ssr-seo]').forEach((element) => {
    if (element.getAttribute('data-ssr-seo') !== currentUrl) element.remove();
  });
};

const buildUrl = (url) => {
  if (!url) return SITE_URL;
  if (/^https?:\/\//i.test(url)) return url;
  return `${SITE_URL}${url.startsWith("/") ? url : `/${url}`}`;
};

export default function useSEO({
  title,
  description,
  keywords,
  url,
  image,
  type = "website",
  robots = "index, follow",
} = {}) {
  useEffect(() => {
    const previousTitle = document.title;
    // url === null indica página sem canonical (ex.: 404).
    const absoluteUrl = url === null ? null : buildUrl(url);
    const absoluteImage = image && /^https?:\/\//i.test(image) ? image : (image ? buildUrl(image) : DEFAULT_IMAGE);

    if (title) document.title = title;
    setMeta("description", description);
    setMeta("keywords", keywords);
    setMeta("robots", robots);
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", absoluteImage);
    setPropertyMeta("og:type", type);
    setPropertyMeta("og:title", title);
    setPropertyMeta("og:description", description);
    if (absoluteUrl) setPropertyMeta("og:url", absoluteUrl);
    setPropertyMeta("og:image", absoluteImage);
    if (absoluteUrl) {
      setCanonical(absoluteUrl);
    } else {
      removeCanonical();
    }
    removeStaleServerSchemas(absoluteUrl);

    return () => {
      if (title) document.title = previousTitle;
    };
  }, [title, description, keywords, url, image, type, robots]);
}
